import React from "react";
import { SettingsResource } from "@/components/settings/tenant/SettingsResource";
import { StatusBadge } from "@/components/kit/StatusBadge";
import { fmtDate, fmtMoney, pubId } from "@/lib/format";

const idCol = { key: "id", label: "ID", mono: true, render: (r) => <span className="text-muted-foreground">{pubId(r)}</span> };
const statusCol = { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> };
const createdCol = { key: "created_at", label: "Created", render: (r) => fmtDate(r.created_at) };
const STATUS_OPTS = ["active", "disabled"];

export function VerticalsTab() {
  return (
    <SettingsResource resource="verticals" title="Vertical" addLabel="Add Vertical"
      columns={[idCol, { key: "name", label: "Name", render: (r) => <span className="font-medium text-foreground">{r.name}</span> },
        { key: "description", label: "Description", render: (r) => <span className="text-muted-foreground">{r.description || "—"}</span> },
        statusCol, createdCol]}
      fields={[{ key: "name", label: "Name", type: "text" }, { key: "description", label: "Description", type: "textarea" },
        { key: "status", label: "Status", type: "select", options: STATUS_OPTS, default: "active" }]} />
  );
}

export function SourcesTab() {
  return (
    <SettingsResource resource="sources" title="Source" addLabel="Add Source"
      columns={[idCol, { key: "name", label: "Name", render: (r) => <span className="font-medium text-foreground">{r.name}</span> },
        { key: "description", label: "Description", render: (r) => <span className="text-muted-foreground">{r.description || "—"}</span> },
        statusCol, createdCol]}
      fields={[{ key: "name", label: "Name", type: "text", placeholder: "Facebook / PPC / SEO / Telegram..." },
        { key: "description", label: "Description", type: "textarea" },
        { key: "status", label: "Status", type: "select", options: STATUS_OPTS, default: "active" }]} />
  );
}

export function PaymentMethodsTab() {
  return (
    <SettingsResource resource="payment_methods" title="Payment Method" addLabel="Add Payment Method" search={false}
      columns={[idCol, { key: "name", label: "Name", render: (r) => <span className="font-medium text-foreground">{r.name}</span> },
        { key: "currency", label: "Currency" }, { key: "network", label: "Network", render: (r) => r.network || "—" },
        { key: "min_withdrawal", label: "Min", align: "right", render: (r) => fmtMoney(r.min_withdrawal) },
        { key: "fee", label: "Fee", align: "right", render: (r) => `${r.fee || 0}%` }, statusCol]}
      fields={[{ key: "name", label: "Name", type: "text" }, { key: "currency", label: "Currency", type: "select", options: ["USDT", "USD", "EUR", "BTC"], default: "USDT" },
        { key: "network", label: "Network", type: "text", placeholder: "TRC20 / ERC20 / —" },
        { key: "min_withdrawal", label: "Min withdrawal", type: "number", default: 50 }, { key: "fee", label: "Fee (%)", type: "number", default: 0 },
        { key: "required_fields", label: "Required fields", type: "text", placeholder: "wallet, memo" },
        { key: "status", label: "Status", type: "select", options: STATUS_OPTS, default: "active" }]} />
  );
}
